<div [formGroup]="formGroupRGPD" class="dialog-default">
  @if (isSportDansLaVille){
    <h1 class="h1" mat-dialog-title><u>Conditions Générales d’activités</u></h1>
  } @else if (isJobDansLaVille) {
    <h1 class="h1" mat-dialog-title><u>Charte d'engagement du Jobbeur</u></h1>
  }
    <mat-dialog-content class="mat-typography">

        @if (isSportDansLaVille) {
            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-title class="h5"></mat-panel-title>
                    <mat-panel-description>
                        Détails
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <p><u>Article 1 : Inscription</u></p>
                <p>L’inscription aux activités proposées par Sport dans la Ville concerne tous les enfants des quartiers
                    dans
                    lesquels Sport dans la Ville dispose de terrains. Pour que l’inscription soit validée les enfants
                    doivent avoir
                    au moins 6 ans révolus.</p>
                <p>L'absence d'inscription digitale avec les autorisations nécessaires, ne permettra pas à l'enfant de bénéficier des activités de Sport dans la Ville pour des raisons de sécurité et d'assurance ; qu'il s'agisse des séances sportives hebdomadaires ou toutes autres sorties et activités proposées par Sport dans la Ville.</p>
                <p>Nous demandons à tous les jeunes de disposer d'une assurance responsabilité civile à jour ; cette
                    assurance de
                    responsabilité civile doit être détenue par le jeune lui-même ou par son représentant légal.</p>
                <p>L'assurance de Sport dans la Ville ne garantit pas les dommages corporels ou matériels des participants aux activités lorsque sa responsabilité n'est pas engagée.</p>
                <br>

                <p>A noter que les séances sportives proposées par Sport dans la Ville sont encadrées par des éducateurs
                    sportifs
                    diplômés ; ceux-ci sont embauchés et suivis par Sport dans la Ville.</p>
                <p>Le fonctionnement et le programme pédagogique des séances est géré par les éducateurs responsables
                    des
                    différents sites. L’objectif étant d’avoir un planning pédagogique harmonisé sur l’ensemble du
                    territoire
                    national, la direction sportive accompagnera et supervisera les éducateurs.</p>
                <p>Sport dans la ville se réserve le droit de refuser l’inscription d’un adhérent pour des raisons de
                    sécurité
                    afin de garantir le bon déroulement des séances (par exemple en cas d’incivilité, de violence, d’un
                    trop
                    grand
                    nombre de jeunes pour mener la séance, …)</p>
                <br>

                <p><u>Article 2 : Respect des personnes et des biens</u></p>
                <p>Chaque enfant s’engage à respecter tous les autres jeunes de l’association, les éducateurs, le
                    matériel,
                    les
                    moyens et équipements mis à leur disposition. Tout manquement de respect pourra être sanctionné par
                    l’éducateur.
                    Celui-ci pourra mettre en place une sanction pédagogique sur le terrain ou, si besoin, exclure le
                    jeune
                    d’une
                    séance ou d’une sortie.</p>
                <p>Les enfants doivent venir en tenue sportive (survêtement, short, t-shirt, basket ou crampons
                    moulé/stabilisés,
                    K-way en cas de pluie, gourde d’eau…).</p>
                <br>

                <p><u>Article 3 : Respect des horaires de séance et de rendez-vous</u></p>
                <p>Les animations sont proposées sur des créneaux horaires fixes, définis en début d’année, en fonction
                    de
                    l’âge
                    des enfants. Chaque enfant s’engage à arriver à l’heure prévue pour sa séance et pour les sorties
                    proposées par
                    l’association. Tout manquement de respect des horaires pourra être sanctionné par l’éducateur.
                    Celui-ci
                    pourra
                    mettre en place une sanction pédagogique sur le terrain ou, en cas de répétition, exclure le jeune
                    d’une
                    séance
                    ou d’une sortie.</p>
                <p>En dehors des créneaux horaires fixés pour chaque catégorie d’âge, les enfants ne sont plus sous la
                    responsabilité de Sport dans la Ville, les éducateurs ne sont donc plus tenus de s’en occuper. Il
                    incombe donc
                    aux parents de venir chercher eux-mêmes leurs enfants dès la fin des séances ou des sorties s’ils le
                    souhaitent. </p>
                <br>

                @if (isMinor) {
                    <p class="h5">Inscription et Autorisation parentale pour mineurs (Sport)</p>
                    <br>

                    <p>• J’autorise la participation de mon enfant à toutes les activités et sorties proposées par Sport
                        dans la
                        Ville.</p>
                    <p>• J’autorise le transport de mon enfant dans le cadre de ces activités et sorties.</p>
                    <p>• J’autorise Sport dans la Ville à prendre, le cas échéant, toute mesure (traitement médical,
                        hospitalisation) jugée nécessaire en cas d’incident survenu dans le cadre des activités de
                        l’association.</p>
                    <br>
                } @else {
                    <p class="h5">Inscription et Autorisation pour majeurs</p>
                    <br>

                    <p>• J’autorise Sport dans la Ville à me faire participer à toutes les activités et sorties
                        proposées
                        par Sport
                        dans la Ville.</p>
                    <p>• J’autorise Sport dans la Ville à me transporter dans le cadre de ces activités et sorties.</p>
                    <p>• J’autorise Sport dans la Ville à prendre, le cas échéant, toute mesure me concernant
                        (traitement
                        médical,
                        hospitalisation) jugée nécessaire en cas d’incident survenu dans le cadre des activités de
                        l’association.</p>
                    <br>
                }
            </mat-expansion-panel>

            @if (isMinor) {
                <mat-checkbox color="primary" formControlName="isInformationValidSport">
                    Je soussigné(e) {{ legalResponsibleName }}, responsable de l’enfant {{ youngName }}, déclare exactes
                    toutes les
                    informations saisies dans le cadre de l’inscription et valide les autorisations précédemment citées
                    pour
                    l'année {{ season.dateStart.getFullYear() }}/{{ season.dateEnd.getFullYear() }} (soit du 1er
                    septembre
                    {{ season.dateStart.getFullYear() }} au 31 août {{ season.dateEnd.getFullYear() }}).
                </mat-checkbox>
            } @else {
                <mat-checkbox color="primary" formControlName="isInformationValidSport">
                    Je soussigné(e) {{ youngName }}, déclare exactes toutes les informations saisies dans le cadre de
                    l’inscription et valide les autorisations précédemment citées pour l'année
                    {{ season.dateStart.getFullYear() }}/{{ season.dateEnd.getFullYear() }} (soit du 1er septembre
                    {{ season.dateStart.getFullYear() }} au 31 août {{ season.dateEnd.getFullYear() }}).
                </mat-checkbox>
            }
        }

        @if (isJobDansLaVille) {
            <mat-expansion-panel class="mat-elevation-z0">
                <mat-expansion-panel-header>
                    <mat-panel-title class="h5"></mat-panel-title>
                    <mat-panel-description>
                        Détails
                    </mat-panel-description>
                </mat-expansion-panel-header>
              <p>Cette charte d’engagements a pour but d’établir les règles de fonctionnement du jobbeur(se) par rapport
                au programme Job dans la Ville afin de faire en sorte que l'accompagnement soit efficace.</p>
              <br>
              <p>En tant que jobbeur(se), je m’engage à adopter les comportements suivants : </p>

              <p>- Je suis volontaire et présent(e) aux activités jusqu’à la fin de la saison : visites, ateliers,
                évènements fédérateurs… et si je suis disponible, je m’engage à participer aux activités pour chaque
                vacances scolaires.</p>
              <p>- Je participe aux temps forts du programme (grands jeux, journée découverte, cérémonies…).</p>
              <p>- Je suis acteur de mon projet et de mon investissement au sein du programme et/ou auprès de mon
                parrain-marraine si j’en ai un(e).</p>
              <p>- Si je suis amené(e) à rechercher une expérience professionnelle, j’exprime clairement ma recherche à
                mon responsable insertion. Je suis ses conseils et participe aux actions qu’il me propose. Je suis
                conscient que la réussite de ma recherche dépend avant tout de moi et pas de mon responsable insertion.
                Je tiens informé(e) mon/ma Responsable Insertion des moindres évolutions (entretiens d’embauche,
                réponses positives, poste, date de démarrage, durée, type de contrat, nom de l’entreprise…).</p>
              <p>- J’ai un comportement professionnel et respectueux : je suis ponctuel(le), assidu(e), je communique en
                amont sur mes empêchements et les justifie, j’ai une tenue professionnelle adaptée et j’adopte des
                règles de bonne conduite et de vivre ensemble.</p>
              <p>- Je respecte les autres jeunes bénéficiaires de l’association, les collaborateurs de Sport dans la
                Ville et ses partenaires. Je respecte également le matériel et les moyens mis à disposition.</p>
              <p>- Si je suis mineur(e) : je facilite une rencontre entre mes parents ou tuteurs légaux et mon
                responsable insertion une fois par an au minimum.</p>
              <p>- Je réponds dans un délai de 24h maximum à mon responsable insertion lorsqu’il m’appelle, m’envoie un
                message ou m’écrit un mail et j’entretiens un contact régulier (une fois par mois) avec mon responsable
                insertion.</p>
              <p>- Je réponds dans un délai de 24h maximum aux partenaires de Sport dans la Ville qui me solliciteraient
                à la suite d’une mise en relation, en faisant valider le contenu de ma réponse par mon responsable
                insertion.</p>
              <p>- Je réponds aux actions qui sollicitent mon avis sur le programme ou une de ses activités
                (questionnaires de satisfactions, focus groupes ; entretiens individuels d’évaluation...).</p>
              <p>Ton responsable insertion est un professionnel qui a pour vocation ta réussite !</p>
              <p>Ton investissement facilite son travail.</p>
              <p>Si tu rencontres des difficultés dans ton accompagnement, tu peux t'adresser à jdlv&#64;sportdanslaville.com</p>
              <br>

              <p class="h5">Assurance</p>
              <br>
              <p>Nous demandons à tous les jeunes de disposer d'une assurance responsabilité civile à jour ; cette assurance de responsabilité civile doit être détenue par le jeune lui-même ou par son représentant légal.</p>
              <p>L'assurance de Sport dans la Ville ne garantit pas les dommages corporels ou matériels des participants aux activités lorsque sa responsabilité n'est pas engagée.</p>
              <br>

                @if(isMinor) {

                    <p class="h5">Inscription et Autorisation parentale pour mineurs (Job)</p>
                    <br>

                    <p>J’autorise la participation de mon enfant à toutes les activités et sorties, y compris sportives,
                        proposées
                        par Sport dans la Ville dans le cadre du <strong>programme Job dans la Ville</strong>.</p>
                    <p>J’autorise le transport de mon enfant dans le cadre de ces activités et sorties. </p>
                    <p>J’autorise Sport dans la Ville à prendre, le cas échéant, toute mesure (traitement médical,
                        hospitalisation)
                        jugée nécessaire en cas d’incident survenu dans le cadre des activités de l’association. </p>
                    <p>J’autorise Sport dans la Ville à proposer à mon enfant un mentor professionnel <span class="blue">ayant signé un contrat moral avec Sport dans la Ville,</span>
                        dans le cadre du programme « Job dans la Ville » et j’autorise ce mentor à accompagner
                        et
                        transporter mon enfant dans le cadre des activités de mentorat.</p>
                } @else {
                    <p class="h5">Inscription et Autorisation pour majeurs</p>
                    <br>

                    <p>J’autorise Sport dans la Ville à me faire participer à toutes les activités et sorties, y compris
                        sportives,
                        proposées par Sport dans la Ville dans le cadre du <strong>programme Job dans la Ville</strong>.
                    </p>
                    <p>J’autorise Sport dans la ville à me transporter dans le cadre de ces activités et sorties. </p>
                    <p>J’autorise Sport dans la Ville à prendre, le cas échéant, toute mesure me concernant (traitement
                        médical,
                        hospitalisation) jugée nécessaire en cas d’incident survenu dans le cadre des activités de
                        l’association. </p>
                    <p>J’autorise Sport dans la Ville à me proposer un mentor professionnel <span class="blue">ayant signé un contrat moral avec Sport dans la Ville,</span>
                        dans le cadre du programme « Job dans la Ville » et j’autorise ce mentor à m'accompagner
                        et me
                        transporter dans le cadre des activités de mentorat.</p>
                }
            </mat-expansion-panel>

            @if(isMinor) {
                <mat-checkbox color="primary" formControlName="isInformationValidJob">
                    Je soussigné(e), responsable de l’enfant, déclare exactes toutes les informations saisies dans le
                    cadre de
                    l’inscription et valide les autorisations précédemment citées pour une durée de un an à compter de
                    ce jour.
                </mat-checkbox>
            } @else {
                <mat-checkbox color="primary" formControlName="isInformationValidJob">
                    Je soussigné(e), déclare exactes toutes les informations saisies dans le cadre de l’inscription et
                    valide les
                    autorisations précédemment citées pour une durée de un an à compter de ce jour.
                </mat-checkbox>
            }
        }

        @if (isRdlv) {
            @if(isMinor) {

                <p class="mt-4">Les places sur les actions du programme Réussite dans la Ville sont limitées. Cette procédure (informations complémentaires sur votre enfant et autorisations) est réalisée dans le cadre d'une préinscription et perdure au stade de l'inscription. Vous serez informés si votre enfant est retenu sur l'action sur laquelle il a été positionné.</p>

                <h2>Assurance</h2>

                <p>Nous demandons à tous les jeunes de disposer d'une assurance responsabilité civile à jour ; cette assurance de responsabilité civile doit être détenue par le jeune lui-même ou par son représentant légal.</p>

                <p>L'assurance de Sport dans la Ville ne garantit pas les dommages corporels ou matériels des participants aux activités lorsque sa responsabilité n'est pas engagée.</p>

                <h2>Préinscription et Autorisation parentale pour mineur (Réussite)</h2>

                <p>J’autorise la participation de mon enfant à toutes les activités et sorties, y compris sportives, proposées par Sport dans la Ville et ses partenaires dans le cadre du programme Réussite dans la Ville.</p>

                <p>J’autorise le transport de mon enfant dans le cadre de ces activités et sorties.</p>

                <p>J’autorise Sport dans la Ville à prendre, le cas échéant, toute mesure (traitement médical, hospitalisation) jugée nécessaire en cas d’incident survenu dans le cadre des activités de l’association.</p>

                <mat-checkbox color="primary" formControlName="isInformationValidRdlv">
                    Je soussigné(e) <i>{{ legalResponsibleName }}</i>, responsable de l’enfant <i>{{ youngName }}</i>, déclare exactes
                    toutes les
                    informations saisies dans le cadre de l’inscription et valide les autorisations précédemment citées
                    pour
                    l'année <i>{{ season.dateStart.getFullYear() }}/{{ season.dateEnd.getFullYear() }}</i> (soit du 1er
                    septembre
                  <i>{{ season.dateStart.getFullYear() }}</i> au 31 août <i>{{ season.dateEnd.getFullYear() }}</i>).
                </mat-checkbox>
            } @else {
                <p class="mt-4">Les places sur les actions du programme Réussite dans la Ville sont limitées. Cette procédure (informations complémentaires et autorisations) est réalisée dans le cadre d'une préinscription et perdure au stade de l'inscription. Vous serez informés si vous êtes retenu sur l'action sur laquelle vous avez été positionné.</p>

                <h2>Assurance</h2>

                <p>Nous demandons à tous les jeunes de disposer d'une assurance responsabilité civile à jour ; cette assurance de responsabilité civile doit être détenue par le jeune lui-même ou par son représentant légal.</p>

                <p>L'assurance de Sport dans la Ville ne garantit pas les dommages corporels ou matériels des participants aux activités lorsque sa responsabilité n'est pas engagée.</p>

                <h2>Préinscription majeur (Réussite)</h2>

                <p>J’accepte de participer à toutes les activités et sorties, y compris sportives, proposées par Sport dans la Ville et ses partenaires dans le cadre du programme Réussite dans la Ville.</p>

                <p>J’autorise Sport dans la Ville à prendre, le cas échéant, toute mesure me concernant (traitement médical, hospitalisation) jugée nécessaire en cas d’incident survenu dans le cadre des activités de l’association.</p>

                <mat-checkbox color="primary" formControlName="isInformationValidRdlv">
                  Je soussigné(e) <i>{{ youngName }}</i>, déclare exactes toutes les informations saisies dans le cadre de
                    l’inscription et valide les autorisations précédemment citées pour l'année
                  <i>{{ season.dateStart.getFullYear() }}/{{ season.dateEnd.getFullYear() }}</i> (soit du 1er septembre
                    <i>{{ season.dateStart.getFullYear() }}</i> au 31 août <i>{{ season.dateEnd.getFullYear() }}</i>).
                </mat-checkbox>
            }
        }

    </mat-dialog-content>

    <mat-dialog-actions class="m-0 d-flex flex-row justify-content-center">
        <button (click)="closePopup()" class="mx-4 col-4 btn btn-primary" mat-button>Valider</button>
    </mat-dialog-actions>
</div>
